import { render } from "./EditorMPM.vue?vue&type=template&id=7178f36f"
import script from "./EditorMPM.vue?vue&type=script&lang=js"
export * from "./EditorMPM.vue?vue&type=script&lang=js"

import "./EditorMPM.vue?vue&type=style&index=0&id=7178f36f&lang=css"

import exportComponent from "/Users/janbergler/NPM/MPM/V3/mpm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__